import { Form } from "react-bootstrap";
import PropsType from "prop-types";

import ErrorMessageArray from "../../utils/ErrorMessageArray";

const CustomFormGroup = (props) => {
  const {
    label,
    name,
    onChange,
    type,
    value,
    placeholder,
    error,
    errorParam,
    required,
    disabled,
  } = props;
  return (
    <>
      <Form.Label>
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </Form.Label>
      {error && ErrorMessageArray(error, errorParam)}
      <Form.Group className="mb-3">
        <Form.Control
          name={name}
          onChange={onChange}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          size="sm"
        />
      </Form.Group>
    </>
  );
};

CustomFormGroup.propsTypes = {
  onChange: PropsType.func.isRequired,
  type: PropsType.string.isRequired,
  name: PropsType.string.isRequired,
};

export default CustomFormGroup;
